import React, { useEffect } from 'react';
import FromNotificationAlert from '../../../../../components/FromNotificationAlert/FromNotificationAlert';
import { useSearchParams } from '../../../shared/lib/searchParams';
import { shutdownFiltersData } from '../../../shared/constants';
import {
  useFromNotificationsSetState,
  useFromNotificationsState,
} from '../model';

const {
  filters: { fromNotification },
} = shutdownFiltersData;

const ShowAndResetFromNotificationsAlert = ({ loading, hasData }) => {
  const locationState = useFromNotificationsState();
  const setLocationsState = useFromNotificationsSetState();
  const [searchParams] = useSearchParams();

  const hasParams = searchParams.has(fromNotification.name);

  useEffect(() => {
    if (!hasParams) {
      setLocationsState(null);
    }
  }, [hasParams]);

  if (loading || !locationState) {
    return null;
  }

  return (
    <FromNotificationAlert
      style={{ textAlign: 'center' }}
      hasData={hasData}
      onClose={() => setLocationsState(null)}
      {...locationState.texts}
    />
  );
};

export default ShowAndResetFromNotificationsAlert;
